import { apiRequest } from './api.js';

export function createAuthService(helium) {
	const sessionChannel = helium.factory('auth:session', null);
	
	const login = async (email, password, signal) => {
		const data = await apiRequest('/api/v1/auth/login', {
			method: 'POST',
			body: JSON.stringify({ email, password }),
			signal
		});
		
		// Guardar token ANTES de llamar a /auth/me
		sessionStorage.setItem('adminToken', data.token);
		
		const user = await apiRequest('/api/v1/auth/me', { signal });
		
		if (!user?.isSaasAdmin) {
			throw new Error('Acceso denegado: Se requieren privilegios de administrador SaaS');
		}
		
		sessionChannel.send(() => user);
		return { ...data, user };
	};
	
	const logout = async (signal) => {
		try {
			await apiRequest('/api/v1/auth/logout', {
				method: 'POST',
				signal
			});
		} catch (error) {
			console.warn('Logout error:', error);
		} finally {
			sessionStorage.removeItem('adminToken');
			sessionChannel.send(() => null);
		}
	};
	
	const getCurrentUser = async () => {
		const token = sessionStorage.getItem('adminToken');
		if (!token) return null;
		
		try {
			const user = await apiRequest('/api/v1/auth/me');
			if (user?.isSaasAdmin) {
				sessionChannel.send(() => user);
				return user;
			}
			return null;
		} catch {
			return null;
		}
	};
	
	return { sessionChannel, login, logout, getCurrentUser };
}
